// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpandOfferCell_wrapper__D6vN+"};